import { useFormikContext } from "formik";
import { FC, useEffect, useState } from "react";
import { useGetListQuery } from "../../../../features/api/Api";
import { isExists, params } from "../../../../utils";

function byString(o: any, s: any) {
  s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
  s = s.replace(/^\./, ""); // strip a leading dot
  var a = s.split(".");
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
}

const UniqueAddressCodeHandler: FC<any> = (props) => {
  const formik = useFormikContext<any>();
  const { data: currentData, isFetching } = useGetListQuery<any>(
    {
      resource:
        "fixity/setting/TurkTelekomAddress/get-address-no-by-doornumber",
      params: {
        ...params,
        pagination: { pageNumber: 0, size: 100 },
        filter: { doorCode: byString(formik.values, props.name).value },
      },
    },
    {
      skip: !byString(formik.values, props.name).value,
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (byString(formik.values, props.name).value && currentData?.data) {
      formik.setFieldValue(props.setName, currentData?.data?.addressNo, false);
    } else {
      formik.setFieldValue(props.setName, 0, false);
    }
  }, [
    byString(formik.values, props.name),
    byString(formik.values, props.name),
    isFetching,
    currentData?.data?.addressNo,
  ]);

  return null;
};

export default UniqueAddressCodeHandler;
